/* Original Tiendanube interactions adapted to server-rendered Shopify sections.
   Does not read or change Kaching, product forms, quantity selectors or cart APIs. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.almaOriginalInit) return;
    root.dataset.almaOriginalInit = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var controller = new AbortController();
    var signal = controller.signal;
    var cleanups = [];
    var slider = root.querySelector('.wigy-comparison-slider');
    var range = root.querySelector('.wigy-comparison-input');
    if (slider && range) {
      var viewButtons = root.querySelectorAll('[data-alma-compare-value]'); var updateSlider = function () { slider.style.setProperty('--clip', range.value + '%'); slider.dataset.fullView = (range.value === '0' || range.value === '100') ? 'true' : 'false'; viewButtons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.almaCompareValue === range.value)); }); }; viewButtons.forEach(function (button) { button.addEventListener('click', function () { range.value = button.dataset.almaCompareValue; updateSlider(); }, {signal: signal}); });
      range.addEventListener('input', updateSlider, {signal: signal});
      updateSlider();
    }
    // Preserve original one-open-accordion behavior without external icon fonts.
    var mainAccordions = document.getElementById('wigy-shopify-faqs-accordion');
    [root.querySelector('#wigy-shopify-faqs-standalone'), mainAccordions].forEach(function (group) {
      if (!group) return;
      group.querySelectorAll('details').forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (detail.open) group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== detail) other.open = false;
          });
        }, {signal: signal});
      });
    });
    var carousel = root.querySelector('.wigy-image-carousel');
    if (carousel) {
      var pause = carousel.querySelector('.alma-pause');
      pause.addEventListener('click', function () {
        var paused = carousel.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.textContent = paused ? 'Reanudar carrusel' : 'Pausar carrusel';
      }, {signal: signal});
      var sizeCarousel = function () {
        var group = carousel.querySelector('.alma-carousel-group');
        var track = carousel.querySelector('.track');
        if (group && track) track.style.setProperty('--alma-carousel-duration', ((group.getBoundingClientRect().width + 8) / 60) + 's');
      };
      sizeCarousel();
      // Prepare the existing five photos shortly before this strip enters the viewport.
      // Horizontal lazy images otherwise arrive as blanks when their frame slides in.
      var prepareImages = function () {
        var images = Array.from(carousel.querySelectorAll('img'));
        images.forEach(function (image) {image.loading = 'eager';});
        Promise.all(images.map(function (image) {
          return image.decode ? image.decode().catch(function () {}) : Promise.resolve();
        })).then(function () {if (carousel.isConnected) carousel.classList.add('is-ready');});
      };
      if ('IntersectionObserver' in window) {
        var preload = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) {return entry.isIntersecting;})) {
            preload.disconnect(); prepareImages();
          }
        }, {rootMargin:'600px 0px'});
        preload.observe(carousel); cleanups.push(function () {preload.disconnect();});
      } else prepareImages();
      if ('ResizeObserver' in window) {
        var carouselSize = new ResizeObserver(sizeCarousel);
        carouselSize.observe(carousel); cleanups.push(function () { carouselSize.disconnect(); });
      }
    }
    // Original guarantee shine, once on first appearance.
    var guarantee = document.getElementById('wigy-garantia-box');
    if (guarantee) {
      if ('IntersectionObserver' in window && !reduced.matches) {
        var shine = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) {
            guarantee.classList.add('wigy-animate'); shine.unobserve(guarantee);
          }});
        }, {threshold: 0.5});
        shine.observe(guarantee); cleanups.push(function () { shine.disconnect(); });
      } else guarantee.classList.add('wigy-animate');
    }
    // Pause continuous effects when off screen or when the page is hidden.
    if ('IntersectionObserver' in window) {
      var animated = Array.from(root.querySelectorAll('.wigy-image-carousel, #wigy-shopify-faqs-standalone'));
      var ticker = document.getElementById('wigy-ticker');
      if (ticker) animated.push(ticker);
      var visibility = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);});
      });
      animated.forEach(function (node) {visibility.observe(node);});
      cleanups.push(function () {visibility.disconnect();});
      document.addEventListener('visibilitychange', function () {
        animated.forEach(function (node) {node.classList.toggle('alma-page-hidden', document.hidden);});
      }, {signal: signal});
    }
    var timeline = root.querySelector('#wigy-timeline-standalone');
    var table = root.querySelector('#wigy-comparison-table-standalone');
    if (timeline) initTimeline(timeline, signal, reduced);
    if (table) {
      var position = function () {positionOverlay(table);};
      position();
      if ('IntersectionObserver' in window && !reduced.matches) {
        var revealTimer;
        var reveal = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) {return entry.isIntersecting;})) {
            reveal.disconnect(); position();
            revealTimer = setTimeout(function () {table.classList.add('wigy-revealed');}, 800);
          }
        }, {threshold:0.2});
        reveal.observe(table); cleanups.push(function () {reveal.disconnect();clearTimeout(revealTimer);});
      } else table.classList.add('wigy-revealed');
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(position); observer.observe(table);
        cleanups.push(function () {observer.disconnect();});
      } else window.addEventListener('resize', position, {passive: true, signal: signal});
      if (document.fonts) document.fonts.ready.then(function () {if (table.isConnected) position();});
    }
    root.almaCleanup = function () {controller.abort();cleanups.forEach(function (fn) {fn();});};
  }
  function initTimeline(wrapper, signal, reduced) {
    if (reduced.matches) return;
    var track = wrapper.querySelector('.timeline-track');
    var fillLine = wrapper.querySelector('.timeline-progress-fill');
    if (!track || !fillLine) return;
    var pills = Array.prototype.slice.call(wrapper.querySelectorAll('.t-pill-orange'));
    var popped = pills.map(function() { return false; });
    var maxFill = 0;
    var rafId = null;

    function triggerPop(pill) {
      pill.classList.remove('pop'); void pill.offsetWidth; pill.classList.add('pop');
      pill.addEventListener('animationend', function() { pill.classList.remove('pop'); }, { once: true });
    }

    function update() {
      rafId = null;
      var rect = track.getBoundingClientRect();
      var triggerPt = window.innerHeight * 0.65;
      var pct = Math.max(0, Math.min(1, (triggerPt - rect.top) / rect.height));
      if (pct > maxFill) {
        maxFill = pct;
        fillLine.style.transform = 'scaleY(' + maxFill + ')';
        pills.forEach(function(pill, i) {
          if (popped[i]) return;
          var pr = pill.getBoundingClientRect();
          var center = pr.top + pr.height / 2 - rect.top;
          if (maxFill >= center / rect.height) { popped[i] = true; triggerPop(pill); }
        });
      }
    }

    window.addEventListener('scroll', function() { if (!rafId) rafId = requestAnimationFrame(update); }, { passive: true, signal: signal });
    window.addEventListener('resize', function() { rafId = requestAnimationFrame(update); }, { passive: true, signal: signal });
    requestAnimationFrame(update);
  }

  function positionOverlay(wrapper) {
    var thBrand = wrapper.querySelector(".th-brand");
    var lastBrand = wrapper.querySelectorAll(".cell-brand");
    var lastCell = lastBrand[lastBrand.length - 1];
    var tableWrapper = wrapper.querySelector(".comp-table-wrapper");
    var overlay = wrapper.querySelector(".comp-brand-bg");
    if (!thBrand || !lastCell || !tableWrapper || !overlay) return;
    var wrapperRect = tableWrapper.getBoundingClientRect();
    var thRect = thBrand.getBoundingClientRect();
    var lastRect = lastCell.getBoundingClientRect();
    overlay.style.top = (thRect.top - wrapperRect.top) + "px";
    overlay.style.left = (thRect.left - wrapperRect.left) + "px";
    overlay.style.width = thRect.width + "px";
    overlay.style.height = (lastRect.bottom - thRect.top) + "px";
  }

  function run() {document.querySelectorAll('[data-alma-tn-root]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true}); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll('[data-alma-tn-root]').forEach(function(root) {if(root.almaCleanup) root.almaCleanup();});
  });
})();
